import {
  ListItemButton,
  ListItemButtonProps,
  ListItemText,
} from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { useTranslation } from 'react-i18next';
import { useShareOrCopy } from 'hooks/useShareOrCopy';
import { LatLng } from 'shared/types';
import {
  COORDINATE_FORMAT_TRANS_KEYS,
  getLocationCoords,
} from 'components/CoordinateSelector';
import { CoordinateFormat } from 'state/useCoordinateFormatState';

type CoordinatesListItemProps = {
  coordinates: LatLng;
  format: CoordinateFormat;
  buttonProps?: ListItemButtonProps;
  blurred?: boolean;
};

/**
 * @deprecated by 'pin_drop_improvements' flag - use <CoordinateSelector> instead
 */
export const CoordinatesListItem = (
  props: CoordinatesListItemProps,
): JSX.Element => {
  const { coordinates, format, buttonProps = {}, blurred } = props;
  const { t } = useTranslation();
  const { copied, shareOrCopyText, reset } = useShareOrCopy();

  const locationCoords = getLocationCoords({
    lat: coordinates.lat,
    lng: coordinates.lng,
    format,
  });

  return (
    <Tooltip
      title={t('common.copied')}
      open={copied}
      placement="top"
      onClose={reset}
      leaveDelay={200}
      slotProps={{ tooltip: { sx: { mb: '-16px !important' } } }}
    >
      <ListItemButton
        divider
        onClick={
          blurred
            ? undefined
            : () =>
                shareOrCopyText({
                  text: locationCoords,
                  showClipboardSuccessMessage: false,
                  androidDialogTitle: t('locationListItem.share'),
                })
        }
        {...buttonProps}
      >
        <ListItemText
          primary={t(COORDINATE_FORMAT_TRANS_KEYS[format])}
          secondary={locationCoords}
          slotProps={{
            primary: {
              color: 'secondary',
              variant: 'h4',
            },
            secondary: {
              variant: 'body1',
              color: 'textPrimary',
              sx: {
                fontWeight: 'fontWeightMedium',
                filter: blurred ? 'blur(3px)' : undefined,
              },
            },
          }}
        />
        <LocationOnIcon sx={{ color: 'text.primary' }} />
      </ListItemButton>
    </Tooltip>
  );
};
